<template>
  <div class="do-root">
    <client-block
    title="Propriétaire"
    icon="fas fa-user"
    id-prefix="proprietaire"
    :value="proprietaire"
    @input="onInput"
  />
  </div>
</template>

<script>
import ClientBlock from './ClientBlock.vue'

function emptyClient() {
  return {
    type            : 'proprietaire',
    type_client     : 'particulier',
    nom             : '',
    prenom          : '',
    siret           : '',
    telephone       : '',
    email           : '',
    regie_id        : 0,
    proprietaire_id : 0,
  }
}

export default {
  name: 'DonneurOrdre',
  components: { ClientBlock },

  props: {
    value: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      proprietaire: { ...emptyClient(), ...this.value?.proprietaire },
    }
  },

  watch: {
    value: {
      deep: true,
      handler(v) {
        const incoming = { ...emptyClient(), ...v?.proprietaire }
        if (JSON.stringify(incoming) !== JSON.stringify(this.proprietaire))
          this.proprietaire = incoming
      }
    }
  },

  methods: {
    onInput(val) {
      this.proprietaire = { ...val, type: 'proprietaire' }
      this.$emit('input', { proprietaire: this.proprietaire })
    }
  }
}
</script>

<style scoped>
.do-root {
  width: 100%;
}
</style>